import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AppAuthGuard} from './guard/app-auth.guard';
import {NgxPermissionsGuard} from 'ngx-permissions';

const routes: Routes = [
  {
    path: 'registration',
    loadChildren: () => import('./registration/registration.module').then(x => x.RegistrationModule)
  },
  {
    path: '',
    loadChildren: () => import('./lounge/lounge.module').then(x => x.LoungeModule),
    canLoad: [NgxPermissionsGuard],
    canActivate: [AppAuthGuard]
  },
  {
    path: 'member',
    loadChildren: () => import('./member/member.module').then(x => x.MemberModule),
    data: {
      permissions: {
        only: ['ADMINISTRATOR', 'ADMINISTRATOR.READ', 'ADMINISTRATOR.WRITE', 'ROSTER.WRITE', 'ROSTER.READ', 'ROSTER.ADMIN', 'SHIFT.ADMIN', 'SHIFT.WRITE', 'SHIFT.READ'],
      }
    },
    canLoad: [NgxPermissionsGuard],
    canActivate: [AppAuthGuard]
  },
  {
    path: 'topsheet',
    loadChildren: () => import('./topsheet/topsheet.module').then(x => x.TopsheetModule),
    data: {
      permissions: {
        // only: ['ADMINISTRATOR', 'ADMINISTRATOR.READ', 'ADMINISTRATOR.WRITE', 'TOPSHEET.WRITE', 'TOPSHEET.READ', 'TOPSHEET.ADMIN'],
        only: [],
      }
    },
    canLoad: [NgxPermissionsGuard],
    canActivate: [AppAuthGuard]
  },
  {
    path: 'client',
    loadChildren: () => import('./client/client.module').then(x => x.ClientModule),
    data: {
      permissions: {
        only: ['ADMINISTRATOR', 'CLIENT.WRITE', 'CLIENT.READ', 'CLIENT.ADMIN'],
      }
    },
    canLoad: [NgxPermissionsGuard],
    canActivate: [AppAuthGuard]
  },
  {
    path: 'payout',
    canActivate: [AppAuthGuard],
    loadChildren: () => import('./payout/payout.module').then(x => x.PayoutModule),
    data: {
      permissions: {
        only: ['ADMINISTRATOR', 'ADMINISTRATOR.READ', 'ADMINISTRATOR.WRITE', 'PAYOUT.WRITE', 'PAYOUT.READ', 'PAYOUT.ADMIN', 'SOMA.WRITE', 'SOMA.READ', 'SOMA.ADMIN'],
        // only: [],
      }
    },
    canLoad: [NgxPermissionsGuard]
  },
  {
    path: 'billing',
    loadChildren: () => import('./billing/billing.module').then(x => x.BillingModule),
    canActivate: [AppAuthGuard],
    data: {
      permissions: {
        // only: ['ADMINISTRATOR', 'ADMINISTRATOR.READ', 'ADMINISTRATOR.WRITE', 'BILLING.WRITE', 'BILLING.READ', 'BILLING.ADMIN'],
        only: [],
      }
    },
    canLoad: [NgxPermissionsGuard]
  },
  { path: 'bookform',
    loadChildren: () => import('./book-form/book-form.module').then(m => m.BookFormModule),
    canActivate: [AppAuthGuard],
    data: {
      permissions: {
        // only: ['ADMINISTRATOR', 'ADMINISTRATOR.READ', 'ADMINISTRATOR.WRITE', 'BOOKS.WRITE', 'BOOKS.READ', 'BOOKS.ADMIN'],
        only: [],
      }
    },
    canLoad: [NgxPermissionsGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(x => x.AdminModule),
    data: {
      permissions: {
        only: ['ADMINISTRATOR', 'ADMINISTRATOR.READ', 'ADMINISTRATOR.WRITE', 'ADMACCT.WRITE', 'ADMACCT.READ', 'ADMACCT.ADMIN', 'ROSTER.WRITE', 'ROSTER.READ', 'ROSTER.ADMIN'],
      }
    },
    canLoad: [NgxPermissionsGuard],
    canActivate: [AppAuthGuard]
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(x => x.AccountModule),
    data: {
      permissions: {
        only: ['ADMINISTRATOR', 'ADMINISTRATOR.READ', 'ADMINISTRATOR.WRITE'],
      }
    },
    canLoad: [NgxPermissionsGuard],
    canActivate: [AppAuthGuard]
  },
  {
    path: 'holiday',
    loadChildren: () => import('./holiday/holiday.module').then(x => x.HolidayModule),
    data: {
      permissions: {
        // only: ['ADMINISTRATOR', 'ADMINISTRATOR.READ', 'ADMINISTRATOR.WRITE', 'HOLIDAY.ADMIN', 'HOLIDAY.READ', 'HOLIDAY.WRITE'],
        only: [],
      }
    },
    canLoad: [NgxPermissionsGuard],
    canActivate: [AppAuthGuard]
  },
  {
    path: 'member-modules',
    loadChildren: () => import('./member-modules/member-modules.module').then(x => x.MemberModulesModule),
    data: {
      permissions: {
        only: ['ADMINISTRATOR'],
      }
    },
    canLoad: [NgxPermissionsGuard],
    canActivate: [AppAuthGuard]
  },
  {
    path : 'job',
    loadChildren : () => import('./job/job.module').then(x => x.JobModule),
    data: {
      permissions: {
        only: ['ADMINISTRATOR'],
      }
    },
    canLoad: [NgxPermissionsGuard],
    canActivate: [AppAuthGuard]
  },
  {
    path : 'accomplishment',
    loadChildren : () => import('./accomplishment/accomplishment.module').then(x => x.AccomplishmentModule),
    data: {
      permissions: {
        // only: ['ADMINISTRATOR'],
        only: [],
      }
    },
    canLoad: [NgxPermissionsGuard],
    canActivate: [AppAuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
